export default class Contract {
  constructor(contractAddress) {
    this.address = contractAddress;
  }
}
